import React from 'react';
import { compose } from 'recompose';
import { withSubscribeEvent } from '../helpers';

const pickerControl = DecoratedComponent =>
    compose(withSubscribeEvent('WDP_TEXTM'))(props => <DecoratedComponent {...props} />);

export default pickerControl;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/hoc/pickerControl.js
 **/